import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2";

export default class extends Controller {
  connect() {
    this.initAll();
  }

  initAll() {
    this.initTomSelect(".tom-select", {
      plugins: ["dropdown_input"],
      allowEmptyOption: true,
    });
    this.initTomSelect(".select-make-trim");
    this.initTomSelect(".select-model-trim");

    this.bindMakeSelects();
    this.bindModelSelects();
  }

  initTomSelect(selector, options = {}) {
    const elems = this.element.querySelectorAll(selector);
    elems.forEach((el) => {
      const existing = el._tomSelectInstance || el.tomselect;
      if (existing) return;
      if (typeof TomSelect === "undefined") return;
      // eslint-disable-next-line no-underscore-dangle
      el._tomSelectInstance = new TomSelect(el, options);
    });
  }

  bindMakeSelects() {
    const makes = this.element.querySelectorAll(".select-make-trim");
    makes.forEach((el) => {
      el.removeEventListener("change", this._handleMakeChange);
      this._handleMakeChange = this.handleMakeChange.bind(this);
      el.addEventListener("change", this._handleMakeChange);
    });
  }

  bindModelSelects() {
    const models = this.element.querySelectorAll(".select-model-trim");
    models.forEach((el) => {
      el.removeEventListener("change", this._handleModelChange);
      this._handleModelChange = this.handleModelChange.bind(this);
      el.addEventListener("change", this._handleModelChange);
    });
  }

  handleMakeChange(event) {
    const select = event.target;
    const makeId = select.value;
    const dataId = select.dataset.id;
    const trimId = dataId;
    const targetId = dataId ? `model_${dataId}` : "model_trim";
    const modelSelect = document.getElementById(targetId);
    if (!modelSelect) return;

    if (!makeId) {
      this.populateModelSelect(modelSelect, []);
      return;
    }

    // Update trim.make_id via PATCH /versoes/:id
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
    if (trimId) {
      fetch(`/versoes/${trimId}`, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...(csrf ? { "X-CSRF-Token": csrf } : {}),
        },
        body: JSON.stringify({ trim: { make_id: makeId } }),
      })
        .then((resp) => {
          if (resp.ok) {
            if (typeof Swal !== "undefined") {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Marca atualizada",
                showConfirmButton: false,
                timer: 2200,
              });
            }
          }
        })
        .catch(() => {});
    }

    // Fetch models for the selected make and populate
    fetch(`/modelos/makes/${makeId}`, {
      headers: { Accept: "application/json" },
    })
      .then((r) => r.json())
      .then((data) => this.populateModelSelect(modelSelect, data))
      .catch(() => {});
  }

  handleModelChange(event) {
    const select = event.target;
    const trimId = select.dataset.id;
    const modelId = select.value;
    if (!trimId) return;
    fetch(`/versoes/update_model/${trimId}/${modelId}`, {
      method: "GET",
      headers: { Accept: "application/json" },
    })
      .then((resp) => {
        if (!resp.ok) throw new Error("network");
        // show success toast immediately
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Modelo atualizado",
          showConfirmButton: false,
          timer: 2200,
        });
        // try to parse name for more info but ignore errors
        return resp.json().catch(() => null);
      })
      .then((json) => {
        if (json) {
          // update toast with model name (non-blocking)
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: `Modelo atualizado: ${json}`,
            showConfirmButton: false,
            timer: 2200,
          });
        }
      })
      .catch(() => {});
  }

  populateModelSelect(modelSelect, data) {
    const ts = modelSelect._tomSelectInstance || modelSelect.tomselect;
    if (ts) {
      try {
        if (typeof ts.clearOptions === "function") ts.clearOptions();
        if (typeof ts.addOption === "function") {
          ts.addOption({ value: "", text: "Selecione o Modelo" });
          data.forEach((m) =>
            ts.addOption({ value: String(m.id), text: m.name }),
          );
        } else {
          modelSelect.innerHTML = "";
          const blank = document.createElement("option");
          blank.value = "";
          blank.textContent = "Selecione o Modelo";
          modelSelect.appendChild(blank);
          data.forEach((m) => {
            const opt = document.createElement("option");
            opt.value = m.id;
            opt.textContent = m.name;
            modelSelect.appendChild(opt);
          });
        }
        if (typeof ts.refreshOptions === "function") ts.refreshOptions(false);
      } catch (e) {
        // ignore
      }
      return;
    }

    modelSelect.innerHTML = "";
    const blank = document.createElement("option");
    blank.value = "";
    blank.textContent = "Selecione o Modelo";
    modelSelect.appendChild(blank);
    data.forEach((m) => {
      const opt = document.createElement("option");
      opt.value = m.id;
      opt.textContent = m.name;
      modelSelect.appendChild(opt);
    });
  }

  disconnect() {
    this.element.querySelectorAll(".select-make-trim").forEach((el) => {
      el.removeEventListener("change", this._handleMakeChange);
    });
    this.element.querySelectorAll(".select-model-trim").forEach((el) => {
      el.removeEventListener("change", this._handleModelChange);
    });
  }
}
